__turbopack_context__.v({
  "allLoaded": "ShopArea-module__lfxECa__allLoaded",
  "allLoadedLine": "ShopArea-module__lfxECa__allLoadedLine",
  "emptyCta": "ShopArea-module__lfxECa__emptyCta",
  "emptyIcon": "ShopArea-module__lfxECa__emptyIcon",
  "emptyState": "ShopArea-module__lfxECa__emptyState",
  "emptySub": "ShopArea-module__lfxECa__emptySub",
  "emptyTitle": "ShopArea-module__lfxECa__emptyTitle",
  "productCell": "ShopArea-module__lfxECa__productCell",
  "productGrid": "ShopArea-module__lfxECa__productGrid",
  "productsSection": "ShopArea-module__lfxECa__productsSection",
  "progressBarFill": "ShopArea-module__lfxECa__progressBarFill",
  "progressBarTrack": "ShopArea-module__lfxECa__progressBarTrack",
  "progressInfo": "ShopArea-module__lfxECa__progressInfo",
  "progressPercent": "ShopArea-module__lfxECa__progressPercent",
  "progressSection": "ShopArea-module__lfxECa__progressSection",
  "progressText": "ShopArea-module__lfxECa__progressText",
  "seeMoreBtn": "ShopArea-module__lfxECa__seeMoreBtn",
  "seeMoreHint": "ShopArea-module__lfxECa__seeMoreHint",
  "seeMoreWrapper": "ShopArea-module__lfxECa__seeMoreWrapper",
  "shopArea": "ShopArea-module__lfxECa__shopArea",
  "shopContainer": "ShopArea-module__lfxECa__shopContainer",
  "simpleContext": "ShopArea-module__lfxECa__simpleContext",
  "simpleShopHeader": "ShopArea-module__lfxECa__simpleShopHeader",
  "simpleShopInner": "ShopArea-module__lfxECa__simpleShopInner",
  "simpleSubtitle": "ShopArea-module__lfxECa__simpleSubtitle",
  "simpleTitle": "ShopArea-module__lfxECa__simpleTitle",
});
